module.exports = __webpack_public_path__ + "img/blue-palm-invited.f4f9e5de.svg";